import React from 'react'
import { registerComponentFn, registerComponentNode, registerModalComponent } from './registrationFns'
import { LoginModalOverlay } from 'common/styleguide/LoginModalOverlay'
import { ClubPoiEditor } from 'features/recumbent/ClubPoiEditor'
import { GlobalNav } from 'common/GlobalNav'
import { SignupModal } from 'common/modals/SignupModal'
import { UpgradeModal, CarouselModal } from 'features/recumbent/UpgradeModal'
import { LeftSidebar, RightSidebar, ContextMenu } from 'features/recumbent/PlannerSidebar'
import { Sidebar } from 'features/recumbent/PlannerSidebar/LegacySidebar'
import { PlannerOnboardingModal } from 'features/recumbent/PlannerOnboardingModal'
import { Gallery } from 'features/gallery/Gallery'
import { RouteSplitter } from 'features/recumbent/RouteSplitter'
import 'lib/hotnessNotifier'
import { CueReviewTool } from 'features/cue_review'
import { LoadExistingApp } from 'features/search/LoadExisting'
import { SaveRouteApp } from 'features/recumbent/SaveRoute'
import { RouteHoverCardLauncher } from 'features/recumbent/RouteHoverCardLauncher'
import { ExportDialog } from 'features/recumbent/ExportDialog/ExportDialog'
import { Route } from 'data/records'
import { DataProvider } from 'data/DataProvider'
import { getCurrentUser } from 'lib/utils'
import { bootCoreShim } from './CoreShim'
import { ModalPaymentForm } from 'features/payments/PaymentForm'
import { HelpPopover } from 'features/HelpPopover'
import tippy from 'tippy.js'
import { tippyDefaults } from 'lib/tippyDefaults'
if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill-locales')
}

tippy(document.body, {
  ...tippyDefaults,
  target: '[data-tip]'
})

const { renderWithinCoreShim } = bootCoreShim()

// SSR Components
if (document.getElementById('globalnav-ssr')) {
  renderWithinCoreShim('globalnav-ssr', <GlobalNav />)
}

// Components that extend the window.rwgps API
registerComponentNode('leftSidebar', LeftSidebar)
registerComponentNode('plannerSidebar', RightSidebar)
registerModalComponent('plannerContextMenu', ContextMenu)
registerModalComponent('signupModal', SignupModal)
registerComponentNode('legacyPlannerSidebar', Sidebar)
registerComponentFn('cueReviewTool', CueReviewTool)
registerComponentFn('routeSplitter', RouteSplitter)
registerModalComponent('paymentForm', ModalPaymentForm)
registerModalComponent('loadExistingModal', LoadExistingApp)
registerModalComponent('saveRouteModal', SaveRouteApp)
registerModalComponent('clubPoiEditor', ClubPoiEditor)
registerModalComponent('loginModalOverlay', LoginModalOverlay)
registerModalComponent('upgradeModal', UpgradeModal)
registerModalComponent('carouselUpgradeModal', CarouselModal)
registerModalComponent('plannerOnboardingModal', PlannerOnboardingModal)
registerModalComponent('gallery', Gallery)
registerModalComponent('advancedExport', ({ legacyRoute, ...props }) => {
  const currentUser = getCurrentUser()
  const routeOverride = legacyRoute && Route.deserialize(legacyRoute).set('_permissions', { customize_export_options: currentUser.accountLevel > 0 })
  return <DataProvider>
    <ExportDialog troute={routeOverride} objectType='route' {...props} />
  </DataProvider>
})
registerComponentNode('routeHoverCard', RouteHoverCardLauncher)
registerComponentNode('helpPopover', HelpPopover)
